// Auth page links
export const authPageLinks = {
  Login: () => '/login',
  Register: () => '/register',
  VerifyEmail: () => '/verify-email',
  RequestPasswordReset: () => '/request-password-reset',
  ResetPassword: () => '/reset-password',
  AuthCallback: () => '/auth/callback',
}
